import { icons, images } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/games_panel.css */

  .static_summary summary {
    display: flex;
    z-index: 1;
    position: relative;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px 20px;
    background-color: var(--summary-background-color);
    transition-property: color, background-color;
  }

  .static_summary summary:hover {
    background-color: hsl(213, 19%, 5%);
    cursor: pointer;
  }

  .static_summary.close summary:hover {
    background-color: hsl(213, 19%, 5%);
    cursor: pointer;
  }

  .static_summary.close summary {
    height: 59px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: transparent;
  }

  .static_summary.close summary h1 .icon {
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;
  }

  .static_summary summary h1 {
    font-size: 0.9rem;
    text-transform: uppercase;
    font-weight: 600;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row;
    display: flex;
    margin: 1px 0 0 0;
    padding: 0 0 0 26px;
    overflow: hidden;
    white-space: nowrap;
  }

  .static_summary summary {
    background-color: var(--summary-background-color);
  }
  .static_summary summary h1 .icon {
    background: rgb(255, 255, 255);
    width: 16px;
    height: 16px;
    position: absolute;
    left: 20px;
    z-index: 1;
  }

  .static_summary summary.static {
    background-color: transparent;
  }

  .static_summary summary h1 .icon {
    -webkit-mask: none;
    mask: none;
    background: url(${icons.wsb_icon_1}) center center / auto 18px no-repeat;
  }
  .static_summary summary {
    border-bottom: 1px solid rgb(45, 52, 62);
    display: flex;
  }
  .static_summary summary.static {
    padding: 15px 20px;
    height: auto;
    background: hsla(0, 0%, 0%, 0.1) url(${images.wsb_banner}) center center / cover no-repeat;
    height: 125px;
  }
`

const developerCSS = css`
  .short_term_prediction {
    text-decoration: none;
  }
  a .external_link_icon {
    background: url(${icons.external_link_icon}) center center / auto 14px no-repeat;
    width: 14px;
    height: 14px;
  }
  .short_term_prediction summary {
    display: flex;
    z-index: 1;
    position: relative;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px 20px;
    background-color: var(--summary-background-color);
    transition-property: color, background-color;
  }

  .short_term_prediction summary:hover {
    background-color: var(--summary-background-color-hover);
    cursor: pointer;
  }
  .short_term_prediction.close summary:hover {
    background-color: var(--summary-background-color-hover);
    cursor: pointer;
  }

  .short_term_prediction.close summary {
    height: 59px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: transparent;
  }

  .short_term_prediction.close summary h1 .icon {
    /* background: rgb(255, 255, 255); */
    width: 24px;
    height: 24px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;
  }

  .short_term_prediction summary h1 {
    font-size: 0.9rem;
    text-transform: uppercase;
    font-weight: 600;
    align-items: center;
    justify-content: flex-start;
    flex-flow: row;
    display: flex;
    margin: 1px 0 0 0;
    padding: 0 0 0 26px;
    overflow: hidden;
    white-space: nowrap;
  }

  .short_term_prediction summary {
    background-color: var(--summary-background-color);
  }
  .short_term_prediction summary h1 .icon {
    background: rgb(255, 255, 255);
    width: 16px;
    height: 16px;
    position: absolute;
    left: 20px;
    z-index: 1;
  }

  .short_term_prediction summary.static {
    background-color: transparent;
  }

  .short_term_prediction summary h1 .icon {
    -webkit-mask: none;
    mask: none;
    background: url(${icons.wsb_icon_1}) center center / auto 18px no-repeat;
  }
  .short_term_prediction summary {
    border-bottom: 1px solid rgb(45, 52, 62);
    display: flex;
  }

  .short_term_prediction summary h1 .icon {
    -webkit-mask: none;
    mask: none;
    background: url(${icons.reddit_icon}) center center / auto 18px no-repeat;
  }

  togCheck:checked + .togContent summary svg.plus {
    visibility: visible;
    opacity: 1;
  }
  svg {
    width: 1em;
    height: 1em;
    fill: currentColor;
  }
`

export const WsbStaticLeftContentCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`
